type CommentMember = {
  userId: string;
  user?: { firstName: string; lastName: string } | null;
};

export function formatCommentTime(createdAt: string): string {
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en-US', { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function buildMemberNameMap(members: CommentMember[]): Map<string, string> {
  return new Map(
    members.map((member) => [member.userId, `${member.user?.firstName || ''} ${member.user?.lastName || ''}`.trim()]),
  );
}

export function renderCommentWithMentions(text: string, memberMap: Map<string, string>) {
  const parts = text.split(/(@\[[^\]]+\])/g);
  return parts.map((part, i) => {
    const match = part.match(/^@\[(.+)\]$/);
    if (match) {
      const displayName = memberMap.get(match[1]) ?? match[1];
      return (
        <span key={i} className="task-board__comment-mention">
          @{displayName}
        </span>
      );
    }
    return part;
  });
}
